var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dt',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.options[_vm.value]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049b26ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Protocolo/View/ModalidadeEnsino.vue
// module id = null
// module chunks = 